module.exports = __webpack_public_path__ + "img/l_animated.143f9221.svg";